import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import Home from './components/Home';
import Navbar from './components/Navbar';
import "@fortawesome/fontawesome-free/css/all.min.css";
import About from './components/About';
import SplashScreen from './components/SplashScreen';
import Project from './components/Project';
import ProjectsPage from './components/ProjectsPage';
import Contact from './components/Contact';
import Dashboard from './components/Admin/Dashboard';
import { ProjectProvider } from './components/Admin/ProjectContext';
import Login from './components/Login/Login';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000); // Splash timeout

    return () => clearTimeout(timer);
  }, []);

  return (
    <ProjectProvider>
      <Router>
        {showSplash ? (
          <SplashScreen />
        ) : (
          <>
            <ScrollToTop />
            {/* <TransitionPage /> */}
            <Navbar />
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/about' element={<About />} />
              <Route path='/projects' element={<ProjectsPage />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/projects/:id' element={<Project />} />
              <Route path='/admin/*' element={<Dashboard />} />
              <Route path='/login' element={<Login />} />
            </Routes>
            <Footer />
          </>
        )}
      </Router>
    </ProjectProvider>
  );
}

export default App;
